import React from "react"
import type { ChakraProps } from "@chakra-ui/react"
import { Text, Box } from "@chakra-ui/react"
import type { LabelValueType } from "@shared/graphql.types"
import { GenericMarkdown } from "../GenericMarkdown"

type Props = ChakraProps & {
  keyIngredients: (LabelValueType | null)[]
}

export const KeyIngredients: React.FC<Props> = ({ keyIngredients }) => {
  return (
    <>
      {keyIngredients &&
        keyIngredients.map((benefit) => (
          <Box key={benefit?.label} mb={2}>
            <Text
              variant="acuminLight"
              fontWeight="600"
              textTransform="uppercase"
              as="h2"
              mt={[0, 1]}
              mb={-1}
            >
              {benefit?.label}
            </Text>
            {benefit?.value && (
              <Text variant="acuminLight" mt={0} as="span" display="flex">
                <strong>+&nbsp;</strong>
                <GenericMarkdown content={benefit.value} />
              </Text>
            )}
          </Box>
        ))}
    </>
  )
}
